import FormSelect from 'components/form/FormSelect';
import FormText from 'components/form/FormText';

import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SignupFormStateType } from '../SignupIndex';
import { getDivSelectOptions } from 'utils/app';

import type { JSX } from 'react';

export function SignupCompanySection({
  register,
  errors,
}: {
  register: UseFormRegister<SignupFormStateType>;
  errors: FieldErrors<SignupFormStateType>;
}): JSX.Element {
  return (
    <>
      {/* 会社情報セクション */}
      <div className="mt-5">
        <div className="row justify-content-center">
          <div className="row form-row flex-md-row justify-content-between">
            <div className="column col-12">
              <h3 className="title-section title-md fw-bold mb-3">会社情報</h3>
            </div>
          </div>
        </div>
      </div>
      {/* 法人名・電話番号 */}
      <div className="row justify-content-center">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="法人名"
              name="companyName"
              placeholder="株式会社BranQ"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormText
              subject="電話番号"
              name="tel"
              placeholder="1234567890"
              register={register}
              errors={errors}
              required={true}
              maxLength={11}
              format="numeric"
              requiredMark={true}
            />
          </div>
        </div>
      </div>
      {/* 郵便番号・都道府県 */}
      <div className="row justify-content-center">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="郵便番号"
              name="zipCode"
              placeholder="1000001"
              register={register}
              errors={errors}
              required={true}
              maxLength={7}
              minLength={7}
              format="numeric"
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormSelect
              subject="都道府県"
              name="prefectureDiv"
              register={register}
              errors={errors}
              options={getDivSelectOptions('prefecture')}
              required={true}
              blank={true}
              blankLabel="選択してください"
              requiredMark={true}
            />
          </div>
        </div>
      </div>
      {/* 市区町村・番地以降 */}
      <div className="row justify-content-center">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="市区町村"
              name="city"
              placeholder="千代田区"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormText
              subject="番地以降"
              name="address"
              placeholder="丸の内1-1-1"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
        </div>
      </div>
      {/* 建物名・部屋番号 */}
      <div className="row justify-content-center">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="建物名・部屋番号"
              name="buildingName"
              placeholder="サンプルビル1F"
              register={register}
              errors={errors}
              maxLength={100}
            />
          </div>
        </div>
      </div>
    </>
  );
}
